// The backend will eventually be returning "the renter" as the default
// We can handle the case where the name is an empty string for now or once it is changed to "the renter"
export default function (name: string) {
  if (!name || name === 'the renter') {
    return 'the renter';
  }
  return name.split(' ')[0];
}
